module.exports = __webpack_public_path__ + "static/media/filter_icon.54d56a1f.svg";